"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _functions = require("../@functions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../@custom/Icon"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
require("../@assets/sass/custom/TextInput.scss");
var _excluded = ["className", "variant", "InputLabelProps", "InputProps", "isPassword", "type", "error", "onChange", "onEnterPress", "onFocus", "onBlur", "value", "disabled", "mask", "maskChar", "maskPlaceholder", "alwaysShowMask", "placeholder"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef TextFieldProps
 * @type {import("@mui/material").TextFieldProps}
 */

/**
 * @typedef ReactInputMaskProps
 * @type {import("react-input-mask").Props}
 */

/**
 * @param {{
 *     ref?: any;
 *     isPassword?: boolean;
 *     onEnterPress?: () => void | Promise<void>;
 *     error?: string;
 * } & Omit<TextFieldProps, "error" | "ref"> & Partial<ReactInputMaskProps>} props
 */
function TextInput(_ref) {
  var _classNames;
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    _ref$InputLabelProps = _ref.InputLabelProps,
    InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    _ref$isPassword = _ref.isPassword,
    isPassword = _ref$isPassword === void 0 ? false : _ref$isPassword,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? '' : _ref$error,
    onChange = _ref.onChange,
    onEnterPress = _ref.onEnterPress,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    value = _ref.value,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    mask = _ref.mask,
    maskChar = _ref.maskChar,
    maskPlaceholder = _ref.maskPlaceholder,
    alwaysShowMask = _ref.alwaysShowMask,
    placeholder = _ref.placeholder,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    passwordVisible = _useState4[0],
    setPasswordVisible = _useState4[1];
  type = !isPassword || passwordVisible ? type : 'password';
  var passwordIcon = passwordVisible ? 'faEye' : 'faEyeSlash';
  var shrink = value || focused;
  var togglePasswordVisibility = function togglePasswordVisibility() {
    return setPasswordVisible(function (prev) {
      return !prev;
    });
  };
  var handleOnFocus = function handleOnFocus(evt) {
    setFocused(true);
    if (onFocus) onFocus(evt);
  };
  var handleOnBlur = function handleOnBlur(evt) {
    setFocused(false);
    if (onBlur) onBlur(evt);
  };
  var props = _objectSpread({
    variant: variant,
    className: (0, _functions.classNames)('TextInput', (_classNames = {}, (0, _defineProperty2["default"])(_classNames, className, !!className), (0, _defineProperty2["default"])(_classNames, 'TextInput--disabled', !!disabled), (0, _defineProperty2["default"])(_classNames, 'TextInput--shrink', shrink), (0, _defineProperty2["default"])(_classNames, 'TextInput--noShrink', !shrink), _classNames)),
    type: type,
    InputLabelProps: _objectSpread({
      shrink: true
    }, InputLabelProps),
    InputProps: _objectSpread({
      endAdornment: isPassword && /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        onClick: togglePasswordVisibility,
        edge: "end"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: passwordIcon
      })))
    }, InputProps),
    placeholder: shrink ? placeholder : undefined,
    error: !!error,
    helperText: error !== null && error !== void 0 ? error : undefined,
    onChange: !mask ? onChange : undefined,
    onFocus: !mask ? handleOnFocus : undefined,
    onBlur: !mask ? handleOnBlur : undefined,
    onKeyPress: function onKeyPress(e) {
      var code = e.key || e.code || e.keyCode || e.which || e.charCode;
      if (code == 13 || code === 'Enter') {
        if (typeof onEnterPress === 'function') onEnterPress(e);
      }
    },
    value: !mask ? value : undefined
  }, rest);
  return mask ? /*#__PURE__*/_react["default"].createElement(_reactInputMask["default"], {
    mask: mask,
    onChange: onChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    value: value,
    maskChar: maskChar,
    maskPlaceholder: maskPlaceholder,
    alwaysShowMask: alwaysShowMask,
    disabled: disabled
  },
  // @ts-ignore
  function () {
    return /*#__PURE__*/_react["default"].createElement(_material.TextField, props);
  }) : /*#__PURE__*/_react["default"].createElement(_material.TextField, props);
}
TextInput.propTypes = {
  tag: _propTypes["default"].string,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  iconed: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  round: _propTypes["default"].bool,
  bgColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  tooltip: _propTypes["default"].string,
  tooltipPosition: _propTypes["default"].string,
  dark: _propTypes["default"].bool,
  textTransform: _propTypes["default"].string,
  outlined: _propTypes["default"].bool,
  InputLabelProps: _propTypes["default"].object,
  InputProps: _propTypes["default"].object,
  isPassword: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].any,
  mask: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  maskChar: _propTypes["default"].string,
  maskPlaceholder: _propTypes["default"].string,
  alwaysShowMask: _propTypes["default"].bool
};
var _default = TextInput;
exports["default"] = _default;